import { render, staticRenderFns } from "./TrainingItemEditorStatusField.vue?vue&type=template&id=6a20535a&"
import script from "./TrainingItemEditorStatusField.vue?vue&type=script&lang=js&"
export * from "./TrainingItemEditorStatusField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports